var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_vm._v("title")]),_c('div',[_c('button',{staticClass:"btn-green",on:{"click":function($event){return _vm.clickLink()}}},[_vm._v("Go Line")])])])}
var staticRenderFns = []

export { render, staticRenderFns }